// extracted by mini-css-extract-plugin
module.exports = {"imgclass":"NumberedCopyBlock_imgclass__ST2cH","sectionHeading":"NumberedCopyBlock_sectionHeading__piWAI"};